// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__15rYY","buttons":"SendReceipts_buttons__1oS8q","email":"SendReceipts_email__18nm_","bookApptTitle":"SendReceipts_bookApptTitle__qITMd"};